import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from 'rtk/query/axiosBaseQuery';
import { EUserType } from 'types/accessControll.types';

type PolicyDto = {
  url: string;
};

export type ThemeDto = {
  id?: string;
  level?: 'basic' | 'advanced';
  agentName?: string;
  // Keeping policies as an array to match backend structure, even though currently only one policy is supported.
  policies?: PolicyDto[];
  brandColor?: string;
  textColor?: string;
  colorScheme?: 'light' | 'dark';
  showOverviewLogo?: boolean;
  favicon?: { light?: string; dark?: string };
  logo?: { light?: string; dark?: string };
  name?: string;
  clientId?: string;
  templateIds?: string[];
  campaignIds?: string[];
  jobIds?: string[];
  applyToClient?: boolean;
};

export const themesApi = createApi({
  reducerPath: 'themesApi',
  baseQuery: axiosBaseQuery({ baseUrl: '/v1/themes' }),
  tagTypes: ['Themes'],
  endpoints: (builder) => ({
    getThemeForClient: builder.query<ThemeDto[], string>({
      query: (clientId) => ({
        url: '',
        method: 'GET',
        params: { clientId },
        headers: { 'X-Access-Control': EUserType.HUBERT },
      }),
      providesTags: ['Themes'],
    }),
    saveTheme: builder.mutation<{ success: boolean; id: string }, ThemeDto>({
      query: (body) => {
        const { id, ...data } = body;
        const isTemp = id?.startsWith('temp-');
        const urlId = isTemp ? '' : id;

        return {
          url: urlId ? `/${urlId}` : '',
          method: 'POST',
          data: isTemp ? data : body,
          headers: { 'X-Access-Control': EUserType.HUBERT },
        };
      },
      invalidatesTags: ['Themes'],
    }),
    removeTheme: builder.mutation<{ success: boolean }, string>({
      query: (themeId) => ({
        url: `/${themeId}`,
        method: 'DELETE',
        headers: { 'X-Access-Control': EUserType.HUBERT },
      }),
      invalidatesTags: ['Themes'],
    }),
  }),
});

export const { useGetThemeForClientQuery, useSaveThemeMutation, useRemoveThemeMutation } = themesApi;
